import { useState, useEffect, useRef } from "react";
import styled from "styled-components";
import { Button, Col, Input, Modal, Pagination, Select, Space, Spin, Table } from "antd";
import { CheckOutlined, DeleteFilled, PlusCircleOutlined, PlusOutlined } from "@ant-design/icons";
import ControlBox from "./ControlBox";
import ImageTabRight from "./ImageTabRight";
import axios from "axios";
import SettingModal from "./SettingModal";
import CreateMeaningPrompt from "./CreateMeaningPrompt";
import CreateBackgroundPrompt from "./CreateBackgroundPrompt";
import CreateImage from "./CreateImage";
import s3Controller from "controllers/s3Controller";

const backend = process.env.REACT_APP_BACKEND;
const StyledTable = styled((props) => <Table {...props} />)`
  && .selectedRow > td {
    background: paleturquoise;
  }
  && .selectedRow:hover > td {
    background: paleturquoise;
  }
  && tbody > tr:hover > td {
    background: azure;
  }
  .ant-table {
    display: flex;
    flex-direction: column;
  }
  .ant-table > .ant-table-container {
    /*flex-grow: 1;*/
    max-height: 92%;
  }

  
  .custom-footer {
    background-color: #fff; /* 적절한 배경색 지정 */
    padding: 10px; /* 원하는 패딩값 설정 */
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .ant-table-pagination.ant-pagination {
    display: none;
  }
  .ant-table-footer {
    width: 100%;
    padding: 0px;
  }
`


function ImageTab ({baseParams, baseParamsHandler, pos}) {

  const [sourceData, setSourceData] = useState([])
  const [loading, setLoading] = useState(false)
  const [selectedRows, setSelectedRows] = useState([]);
  const [selectedKeys, setSelectedKeys] = useState([]);
  const [rightBox, setRightBox] = useState([false,{}])
  const [settingModal, setSettingModal] = useState(false)
  const [gptModel, setGptModel] = useState({})
  const [progressBar, setProgressBar] = useState([0,0])
  const [rowIndex, setRowIndex] = useState(null)
  const stopRef = useRef(false)
  const newPageRef = useRef(false)

  const [tableParams, setTableParams] = useState({
    pagination: {
      current: 1, // 현재 표시할 페이지
      pageSize: 100, // 한 페이지에 표시할 레코드 수
      showSizeChanger: true, // pageSize변경옵션을 표시할지 여부
      pageSizeOptions: [5, 10, 50, 100, 200],
      showQuickJumper: true, // page 점프
      hideOnSinglePage: false, //pagenation 자체를 사용하고 싶지 않은 경우 pageSize를 최고로 높이면 됨
      showTotal: (total)=>`total ${total} items`,
      total:0
    },
    filters: {
    },
    sorter: {
    }
  });

  const tableParamsHandler = (pagination, filter, sorter) => {
    setTableParams({
      ...tableParams,
      pagination: {
        ...tableParams.pagination,
        current:1
      },
      sorter
    })
  }
  const paginationHandler = (current,pageSize) => {
    setTableParams({
      ...tableParams,
      pagination: {
        ...tableParams.pagination,
        current: pageSize === tableParams.pagination.pageSize ? current : 1,
        pageSize: pageSize,
      }
    })
  }

  const dataChangeHandler = (record, column) => {
    // state의 변경 전에 임의로 바꾸는 것은 꼼수
    sourceData[record.indexNumber][column] = record[column]
    sourceData[record.indexNumber].dalle_id = record.dalle_id

    const instance = sourceData.slice()
    instance.splice(record.indexNumber, 1, record)
    setSourceData(instance)
    if(rightBox[0] && record.indexNumber === rowIndex){
      setRightBox([true, record])
    }
  }

  const stateHandler = (stateName, state) => {
    switch (stateName) {
      case "loading" :
        setLoading(state)
        break
      case "settingModal" :
        setSettingModal(state)
        break
      case "gptModel" :
        setGptModel(state)
        break
      case "progressBar" : 
        setProgressBar(state)
        break
      case "rightBox" :
        setRightBox(state)
        break
      case "rowIndex" :
        setRowIndex(state)
        break
      case "tableParams" :
        setTableParams(state)
        break
      case "newPageRef" :
        newPageRef.current = state
        break
      case "sourceDataForRightBox" :
        const instance = sourceData.slice()
        instance.splice(state.indexNumber, 1, state)
        setSourceData(instance)
        if(rightBox[0]) {
          setRightBox([true, state])
        }
        break

      default : break
    }
  }

  const prompt = {
    meaningPrompt : `Create a prompt for Dall E 3 to generate an image describing the word {word_en} when meaning {word_ko}. Your prompt should be written to help viewers better understand the meaning of the word. Make sure to ask for the correct number of items depending on singular or plural nouns. The sentence should be mentioned in the prompt, but NO text or written signs of the sentence should be in the image. Provide only the prompt without any heading or additional signaling cues.`,
    backgroundPrompt : `Create a prompt for Dall E 3 to generate a background image that helps viewers understand the meaning of "{}". Make sure to include the sentence in your prompt. Provide only the prompt without any heading or additional signaling cues.`
  }

  const columns = [
    {
      title: "영어단어",
      dataIndex: "word",
      key: "word",
      width: "150px",
      sorter: (a,b) => a.word-b.word
    },
    {
      title: "품사",
      dataIndex: "pos_name",
      key: "pos_name",
      width: "130px"
    },
    {
      title: "CEFR레벨(EVP)",
      dataIndex: "cefr_evp",
      key: "cefr_evp",
      width: "140px"
    },
    {
      title: "CEFR레벨(GPT)",
      dataIndex: "cefr_gpt",
      key: "cefr_gpt",
      width: "150px",
    },
    {
      title: "해석",
      dataIndex: "translate_text",
      key: "translate_text",
      width: "220px",
    },
    {
      title: "의미 프롬프트",
      dataIndex: "meaning_prompt",
      key: "meaning_prompt",
      width: "110px",
      render: (_)=>_ ? <CheckOutlined /> : null
    },
    {
      title: "프롬프트 생성",
      dataIndex: "",
      key: "",
      width: "110px",
      render: (_,record) => <CreateMeaningPrompt record={record} prompt={prompt} gptModel={gptModel} dataChangeHandler={dataChangeHandler}/>
    },
    {
      title: "배경 프롬프트",
      dataIndex: "background_prompt",
      key: "",
      width: "110px",
      render: (_)=>_ ? <CheckOutlined /> : null
    },
    {
      title: "프롬프트 생성",
      dataIndex: "",
      key: "",
      width: "110px",
      render: (_,record) => <CreateBackgroundPrompt record={record} prompt={prompt} gptModel={gptModel} dataChangeHandler={dataChangeHandler}/>
    },
    {
      title: "이미지 수",
      dataIndex: "image_count",
      key: "image_count",
      width: "100px",
    },
    {
      title: "이미지 처리",
      dataIndex: "",
      key: "",
      width: "110px",
      render: (_,record) => <CreateImage record={record} gptModel={gptModel} dataChangeHandler={dataChangeHandler}/>
    },
    {}
  ]
  
  const getSourceData = () => {
    setLoading(true)
    const { current, pageSize } = tableParams.pagination;
    const sorterCol = tableParams.sorter.column?.dataIndex || "id"
    const sorterDirection = tableParams.sorter.order === "ascend" ? "ASC" : "DESC"

    axios
      .get(`${backend}/contents/new_word/image/list`,
      {params:{
        ...baseParams,
        current: current,
        pageSize: pageSize,
        sorterCol: sorterCol,
        sorterDirection: sorterDirection
      }})
      .then(res=>{
        const newSourceData = res.data.data[0].map((el,idx)=>{
          el.indexNumber = idx
          return el
        })
        setSourceData(newSourceData)
        setTableParams({
          ...tableParams,
          pagination: {
            ...tableParams.pagination,
            total: res.data.data[1][0]["FOUND_ROWS()"]
          }
        })
        setSelectedKeys([])
        setSelectedRows([])
        newPageRef.current = false

        if(rowIndex !== null) {
          if(rowIndex < newSourceData.length) {
            setRightBox([true, newSourceData[rowIndex]])
          } else {
            setRightBox([false,{}])
            setRowIndex(null)
          }
        }
      })
      .catch(err=>{
        console.log(err)
      })
      .finally(()=>{
        setLoading(false)
      })
  }

  const rowSelection = {
    selectedRowKeys: selectedKeys,
    type: "checkbox",
    onChange: (keys, rows) => {
      setSelectedRows(rows.sort((a, b) => a.indexNumber - b.indexNumber));
      setSelectedKeys(keys.sort((a, b) => a - b));
    },
    getCheckboxProps: (record) => ({
      // disabled: record.hideCheckbox, // 특정 조건일 경우 사용하지 체크하지 못하도록 함
      // className: record.hideCheckbox ? "hidden-checkbox" : "" // 클래스 설정 가능

    })
  }

  // 각 행별 이벤트를 모아놓은 객체를 리턴한다. 필요한 경우에만 사용하도록.
  const onRowHandler = (record, rowIdx) => {
    return {
      onClick : () => {
        if(rowIdx === rowIndex) {
          setRowIndex(null)
        } else {
          setRowIndex(rowIdx)
        }
      }
    }
  }

const deleteSelectedWordsImages = () => {
  axios.delete(`${backend}/contents/new_word/image/list/new-image/${selectedKeys}`)
  .then(res=>{
    const files = res.data.data.map(el=>{
      return {Key: "word_image/"+el.word_image_filename}
    })
    
    s3Controller.s3DeleteFiles(files,(err,data)=>{
      if (err) console.log(err)
    })
    const instance = sourceData.map(el=>{
      if(selectedKeys.indexOf(el.id) !== -1) {
        el.image_count = null
      }
      return el
    })
    getSourceData()
  })
  .catch(err=>{
    console.log(err)
  })
}

  useEffect(()=>{
    //페이지 전환 시 기존데이터로 렌더링되었다가 새로운 데이터로 렌더링 되는 깜빡임을 없애기 위함.
    if(newPageRef.current) return
    if(rowIndex !== null) {
      setRightBox([true, sourceData[rowIndex]])
    } else {
      setRightBox([false,{}])
    }
  },[rowIndex])

  useEffect (()=>{
    getSourceData()
  },[JSON.stringify(baseParams), tableParams.pagination.pageSize, tableParams.pagination.current, tableParams.sorter])
  
  useEffect(()=>{
    axios.get(`${backend}/contents/new_word/image/gpt`)
    .then(res=>{
      setGptModel(res.data.data[0])
    })
    .catch(err=>{
      console.log(err)
    })
  },[])

  return (
    <div style={{display: "flex", flexDirection:"column", height:"100%"}}>

      <SettingModal 
        settingModal={settingModal}
        stateHandler={stateHandler}
        gptModel={gptModel}
      />
      <Spin className="mySpin" spinning={loading} tip={
        progressBar[0] ?
        <>
        <div>{`${progressBar[0]} 개 단어 중..${progressBar[1]}개 진행중...`}</div>
        <Button onClick={()=>{stopRef.current=true}}>중지</Button>
        </> : null
      }>
        <div style={{display:"flex", justifyContent:"space-between", marginBottom:"10px"}}>
          <span style={{ minWidth: "100px", textAlign: "left" }}>단어 목록</span>
          <ControlBox 
            baseParams={baseParams} 
            baseParamsHandler={baseParamsHandler} 
            pos={pos}
            tableParams={tableParams}
            paginationHandler={paginationHandler}
            stateHandler={stateHandler}
            selectedRows={selectedRows}
            prompt={prompt}
            gptModel={gptModel}
            dataChangeHandler={dataChangeHandler}
            stopRef={stopRef}
          />
        </div>
        
        <div style={{ display: "flex", height:"100%", width:"100%", overflow: "auto" }}>
          <StyledTable
            className="pageTable"
            onRow={onRowHandler}
            rowClassName={(record, index) => {
              return index === rowIndex ? "selectedRow" : "";
            }}
            rowSelection={rowSelection}
            columns={columns}
            dataSource={sourceData}
            rowKey="id"
            onChange={tableParamsHandler}
            pagination={tableParams.pagination}
            style={{flexGrow:1, overflow:"auto"}}
            scroll = {{ x:"max-content", y:"max-content"}}
            footer={()=>
              <div className="custom-footer">
                <Button onClick={deleteSelectedWordsImages}  disabled={!selectedRows.length}>
                  <DeleteFilled/>선택단어의 이미지 삭제
                </Button>
                {
                  tableParams.pagination.total
                  ? <Pagination {...tableParams.pagination} onChange={paginationHandler}/>
                  : null
                }
              </div>}
          ></StyledTable>
          {
            rightBox[0] 
            ? <ImageTabRight 
                stateHandler={stateHandler}
                prompt={prompt}
                rightBox={rightBox}
                tableParams={tableParams}
                gptModel={gptModel}
              /> 
            : null
          }
        </div>
      </Spin>
    </div>
  )
}

export default ImageTab